export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7737.6e6bb06d.jpg";